import React, { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import Autocomplete from "../../components/Autocomplete";
import SearchResultList from "./components/SearchResultList";

const SearchResults = ({ navigate, location }) => {
  const [filterItems, setFilterItems] = useState([]);

  const resetFilter = () => {
    setFilterItems([]);
  };

  /**
   * Adds or removes an item from the filter array
   */
  const toggleFilter = (filterItem) => {
    setFilterItems((prev) =>
      prev.includes(filterItem)
        ? prev.filter((item) => item !== filterItem)
        : [...prev, filterItem]
    );
  };

  const isInFilter = (item) => filterItems.includes(item);

  return (
    <Container className="search-results">
      <Row className="no-gutters">
        <Col>
          <Autocomplete
            onSelect={resetFilter}
            navigate={navigate}
            location={location}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <SearchResultList
            filterItems={filterItems}
            toggleFilter={toggleFilter}
            isInFilter={isInFilter}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SearchResults;
